import { render, staticRenderFns } from "./MassrecordDetails.vue?vue&type=template&id=bd9642b6&scoped=true"
import script from "./MassrecordDetails.vue?vue&type=script&lang=js"
export * from "./MassrecordDetails.vue?vue&type=script&lang=js"
import style0 from "./MassrecordDetails.vue?vue&type=style&index=0&id=bd9642b6&prod&lang=less&scoped=true"
import style1 from "./MassrecordDetails.vue?vue&type=style&index=1&id=bd9642b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9642b6",
  null
  
)

export default component.exports